import { render, staticRenderFns } from "./TheUsers.vue?vue&type=template&id=83f0a0c6&"
import script from "./TheUsers.vue?vue&type=script&lang=ts&"
export * from "./TheUsers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports